import gql from 'graphql-tag';

export const GET_APPLICATION = gql`
  query application($applicationID: String!) {
    application(applicationID: $applicationID) {
      applicationName
      applicationID
      developerID
      jwtTokenExpiration
      jwtServerTokenExpiration
      clientTokenScopes
      serverTokenScopes
      clientID
      clientSecret
      privateKey
      publicKey
      domain
      federationType
      version
      appType
      childAppName
      jwtOAuth2TokenExpiration
      oauth2TokenScopes
      oauth2FriendlyName
      oauth2RedirectURI
      jwtOAuth2ServerTokenExpiration
      oauth2ServerTokenScopes
      oauth2Providers {
        type
        clientID
        clientSecret
      }
      oauth2SelfProvisionDisabled
      oauth2EmailVerificationEnabled
      oauth2EmailVerificationGracePeriod
      oauth2EmailVerificationExpiration
      oauth2ShouldValidateEmail
    }
  }
`;

export const GET_APPLICATION_OWNER = gql`
  query applicationOwner($applicationID: String!) {
    applicationOwner(applicationID: $applicationID) {
      _id
      ownerID
      createdBy
      fields {
        applicationName
        applicationID
      }
    }
  }
`;

export const GET_USER = gql`
  query user($userID: String!) {
    user(userID: $userID) {
      user_id
      auminfo {
        user_name
        first_name
        last_name
        middle_name
        email
      }
    }
  }
`;

export const GET_USERS = gql`
  query($filter: String!, $skip: Int!, $limit: Int!) {
    users(filter: $filter, skip: $skip, limit: $limit) {
      users {
        user_id
        type
        type_id
        auminfo {
          user_name
          email
        }
      }
      skip
      limit
      count
    }
  }
`;

export const GET_DOMAIN_USERS = gql`
  query($domain: String!, $filter: String!, $skip: Int!, $limit: Int!) {
    domainUsers(domain: $domain, filter: $filter, skip: $skip, limit: $limit) {
      users {
        user_id
        type
        type_id
        timestamp
        auminfo {
          user_name
          email
          disabled
          disabledDesc
          disabledTime
          last_login_time
        }
      }
      skip
      limit
      count
    }
  }
`;

export const GET_TEAM = gql`
  query team($id: String) {
    team(id: $id) {
      team_id
      display_name
    }
  }
`;

export const GET_TEAMS = gql`
  query teamsForCurrentUser {
    teamsForCurrentUser {
      team_id
      display_name
      user_role
    }
  }
`;

export const UPDATE_APPLICATION_OWNER = gql`
  mutation changeAppOwner($appid: String!, $newownerID: String!) {
    changeAppOwner(id: $appid, newOwnerID: $newownerID) {
      _id
      ownerID
      fields {
        applicationName
        applicationID
      }
    }
  }
`;

export const DISABLE_USER = gql`
  mutation disableUser($disabledDesc: String!, $isDisabled: Boolean!, $userId: String!) {
    disableUser(disabledDesc: $disabledDesc, isDisabled: $isDisabled, userId: $userId) {
      user_id
      type
      type_id
      timestamp
      auminfo {
        user_name
        email
        disabled
        disabledDesc
        disabledTime
        last_login_time
      }
    }
  }
`;

export const REVOKE_USER = gql`
  mutation revokeUser($userId: String!) {
    revokeUser(userId: $userId)
  }
`;

export const GET_CLIENT_ID = gql`
  query clientID($applicationID: String!) {
    applicationClientID(applicationID: $applicationID)
  }
`;

export const GET_CLIENT_SECRET = gql`
  query clientSecret($applicationID: String!) {
    applicationClientSecret(applicationID: $applicationID)
  }
`;

export const GET_PRIVATE_KEY = gql`
  query privateKey($applicationID: String!) {
    applicationPrivateKey(applicationID: $applicationID)
  }
`;

export const UPDATE_APPLICATION = gql`
  mutation application($application: ApplicationInput!, $currentTeam: String!) {
    application(application: $application, currentTeam: $currentTeam) {
      applicationID
    }
  }
`;

export const GET_PING_ID = gql`
  query pingID($appKey: String!) {
    pingID(appKey: $appKey) {
      app_key
      auth_string
      server_url
    }
  }
`;

export const UPDATE_PING_ID = gql`
  mutation pingID($pingID: PingIDInput!) {
    pingID(pingID: $pingID) {
      app_key
      auth_string
      server_url
    }
  }
`;

export const APN_KEY_CERT = gql`
  query apnKeyCert($appKey: String!) {
    apnKeyCert(appKey: $appKey) {
      app_key
      apns_cert
      apns_key
      apns_production
    }
  }
`;

export const GET_SSO = gql`
  query sso($appKey: String!) {
    sso(appKey: $appKey) {
      app_key
      server_url
    }
  }
`;

export const APN_AUTH_TOKEN = gql`
  query apnAuthToken($appKey: String!) {
    apnAuthToken(appKey: $appKey) {
      app_key
      app_domain_client_id
      app_domain
      apns_team_id
      apns_key_id
      apns_priv_key
      apns_production
    }
  }
`;

export const UPDATE_SSO = gql`
  mutation sso($sso: SsoInput!) {
    sso(sso: $sso) {
      app_key
      server_url
    }
  }
`;

export const FGCM = gql`
  query fgcm($appKey: String!) {
    fgcm(appKey: $appKey) {
      app_key
      app_domain_client_id
      app_domain
      gcm_api_key
    }
  }
`;

export const GET_TOKEN_EXCHANGE = gql`
  query tokenExchange($appKey: String!) {
    tokenExchange(appKey: $appKey) {
      app_key
      current_alg
      public_key_text
      unique_id_claim
    }
  }
`;

export const UPDATE_APN_KEY_CERT = gql`
  mutation apnKeyCert($apnKeyCert: ApnKeyCertInput!) {
    apnKeyCert(apnKeyCert: $apnKeyCert)
  }
`;

export const UPDATE_TOKEN_EXCHANGE = gql`
  mutation tokenExchange($tokenExchange: TokenExchangeInput!) {
    tokenExchange(tokenExchange: $tokenExchange) {
      app_key
      current_alg
      public_key_text
      unique_id_claim
    }
  }
`;

export const UPDATE_APN_AUTH_TOKEN = gql`
  mutation apnAuthToken($apnAuthToken: ApnAuthTokenInput!) {
    apnAuthToken(apnAuthToken: $apnAuthToken)
  }
`;

export const ROTATE_CREDENTIALS = gql`
  mutation rotateApplicationCredentials($applicationID: String!) {
    rotateApplicationCredentials(applicationID: $applicationID) {
      clientID
      clientSecret
    }
  }
`;

export const UPDATE_FGCM = gql`
  mutation updateFgcm($fgcm: FgcmInput!) {
    updateFgcm(updateFgcm: $fgcm)
  }
`;

export const ROTATE_KEYS = gql`
  mutation rotateApplicationKeys($applicationID: String!) {
    rotateApplicationKeys(applicationID: $applicationID) {
      privateKey
      publicKey
    }
  }
`;

export const ROTATE_ALL = gql`
  mutation rotateAll($applicationID: String!) {
    rotateApplicationCredentials(applicationID: $applicationID) {
      clientID
      clientSecret
    }
    rotateApplicationKeys(applicationID: $applicationID) {
      privateKey
      publicKey
    }
  }
`;
